module.exports = __webpack_public_path__ + "static/media/mlogo.d22fc365.png";